"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_logo_1 = require("@campgladiator/cgui-core.atoms.logo");
const cgui_core_utilities_helpers_resolution_variables_1 = require("@campgladiator/cgui-core.utilities.helpers.resolution-variables");
const cgui_core_atoms_button_1 = require("@campgladiator/cgui-core.atoms.button");
const cgui_core_utilities_hooks_use_device_width_1 = require("@campgladiator/cgui-core.utilities.hooks.use-device-width");
const cgui_core_atoms_avatar_1 = require("@campgladiator/cgui-core.atoms.avatar");
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const cgui_core_molecules_list_menu_1 = require("@campgladiator/cgui-core.molecules.list-menu");
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const generateSandwichMenu_1 = require("./generateSandwichMenu");
const header_search_bar_1 = require("./components/header-search-bar");
const accessory_item_1 = require("./components/accessory-item");
const header_module_scss_1 = __importDefault(require("./header.module.scss"));
const MenuItemsLine = (item, index) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const isActiveRoute = item.isActiveRoute;
    return (react_1.default.createElement("li", { className: (0, classnames_1.default)(header_module_scss_1.default.item, {
            [header_module_scss_1.default.show]: show,
        }), key: index, onClick: () => setShow(!show), onMouseEnter: () => setShow(true), onMouseLeave: () => setShow(false) },
        react_1.default.createElement("a", { target: item.newTab ? "_blank" : "_self", className: header_module_scss_1.default.link, href: item.link },
            react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "small", style: isActiveRoute ? { color: "#333333" } : {}, weight: isActiveRoute ? "normal" : "book" }, item.label)),
        item.items && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { name: "icon-angle-down", className: header_module_scss_1.default.arrowIcon })),
        item.items && (react_1.default.createElement(cgui_core_molecules_list_menu_1.ListMenu, { items: item.items, className: (0, classnames_1.default)(header_module_scss_1.default.itemListHeader, {
                [header_module_scss_1.default.show]: show,
            }) }))));
};
const MenuItems = ({ headerLinks }) => {
    return (react_1.default.createElement("div", { className: header_module_scss_1.default.headerLinksContainer },
        react_1.default.createElement("ul", { className: header_module_scss_1.default.list }, headerLinks === null || headerLinks === void 0 ? void 0 : headerLinks.filter((item) => !item.isHidden).map((item, index) => MenuItemsLine(item, index)))));
};
const SandwichButton = ({ mappedItems, isLoggedIn, theme, }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(header_module_scss_1.default.sandwichButton, isLoggedIn ? header_module_scss_1.default.isLoggedIn : header_module_scss_1.default.isNotLoggedIn, {
            [header_module_scss_1.default.show]: show,
        }), onClick: () => setShow(!show), onMouseEnter: () => setShow(true), onMouseLeave: () => setShow(false) },
        react_1.default.createElement("button", { className: (0, classnames_1.default)(header_module_scss_1.default.item) },
            react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { name: "icon-bars" })),
        react_1.default.createElement(cgui_core_molecules_list_menu_1.ListMenu, { items: mappedItems, className: (0, classnames_1.default)(header_module_scss_1.default.itemListHeader, {
                [header_module_scss_1.default.show]: show,
            }), theme: theme })));
};
const HeaderButton = (props) => {
    const deviceWidth = (0, cgui_core_utilities_hooks_use_device_width_1.useDeviceWidth)();
    let size = "small";
    if (deviceWidth < cgui_core_utilities_helpers_resolution_variables_1.breakpoints.tabletSmall)
        size = "xsmall";
    return (react_1.default.createElement("div", { className: header_module_scss_1.default.buttonContainer },
        react_1.default.createElement(cgui_core_atoms_button_1.Button, Object.assign({}, props, { size: size }), props.label)));
};
const HeaderAvatar = ({ avatar, items, onLogoutClick, userName, }) => {
    const { tabletMedium } = cgui_core_utilities_helpers_resolution_variables_1.breakpoints;
    const deviceWidth = (0, cgui_core_utilities_hooks_use_device_width_1.useDeviceWidth)();
    const avatarSize = deviceWidth > tabletMedium ? "30px" : "24px";
    const [show, setShow] = (0, react_1.useState)(false);
    const logoutItem = [
        { type: "divider" },
        {
            type: "item",
            text: "Log Out",
            itemId: "6",
            onClick: onLogoutClick,
        },
    ];
    return (react_1.default.createElement("div", { className: header_module_scss_1.default.userButtonContainer },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(header_module_scss_1.default.userButton, {
                [header_module_scss_1.default.show]: show,
            }), onClick: () => setShow(!show), onMouseEnter: () => setShow(true), onMouseLeave: () => setShow(false) },
            react_1.default.createElement(cgui_core_atoms_avatar_1.Avatar, { size: avatarSize, src: avatar === null || avatar === void 0 ? void 0 : avatar.src }),
            userName && react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "small" }, userName),
            react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { name: "icon-angle-down", className: header_module_scss_1.default.arrowIcon }),
            !!items && (react_1.default.createElement(cgui_core_molecules_list_menu_1.ListMenu, { items: items === null || items === void 0 ? void 0 : items.concat(logoutItem), className: (0, classnames_1.default)(header_module_scss_1.default.itemListHeader, {
                    [header_module_scss_1.default.show]: show,
                }) })))));
};
const HeaderButtons = ({ buttons }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, buttons.map((buttonProps, index) => (react_1.default.createElement(HeaderButton, Object.assign({}, buttonProps, { key: index }))))));
};
const CollapsedHeader = (0, react_1.forwardRef)(({ headerLinks, isLoggedIn = false, deviceWidth, accessoryItem, buttons, userButton, loginUrl, theme, onLogoutClick, searchBar, }, ref) => {
    const { tabletMedium, tabletLarge } = cgui_core_utilities_helpers_resolution_variables_1.breakpoints;
    const exceedsTabletSize = deviceWidth > (searchBar ? tabletLarge : tabletMedium);
    const shouldAddAccessoryItem = exceedsTabletSize || !accessoryItem;
    const showAccessoryItem = accessoryItem && exceedsTabletSize;
    const isLoggedInAndHasUserButton = isLoggedIn && userButton;
    const mappedItems = (0, generateSandwichMenu_1.generateSandwichMenu)({
        headerLinks: shouldAddAccessoryItem
            ? headerLinks
            : [...headerLinks, accessoryItem],
        isLoggedIn,
        loginUrl,
    });
    return (react_1.default.createElement("div", { className: header_module_scss_1.default.collapsedMenuItemsContainer },
        searchBar && react_1.default.createElement(header_search_bar_1.HeaderSearchBar, Object.assign({}, searchBar, { ref: ref })),
        showAccessoryItem && react_1.default.createElement(accessory_item_1.AccessoryItem, Object.assign({}, accessoryItem)),
        isLoggedInAndHasUserButton && (react_1.default.createElement(HeaderAvatar, Object.assign({}, userButton, { onLogoutClick: onLogoutClick }))),
        react_1.default.createElement(HeaderButtons, { buttons: buttons }),
        mappedItems.length !== 0 && (react_1.default.createElement(SandwichButton, { mappedItems: mappedItems, isLoggedIn: isLoggedIn, theme: theme }))));
});
const LargeHeader = (0, react_1.forwardRef)(({ accessoryItem, headerLinks, isLoggedIn, buttons, loginUrl, userButton, onLogoutClick, searchBar, }, ref) => (react_1.default.createElement(react_1.default.Fragment, null,
    searchBar && react_1.default.createElement(header_search_bar_1.HeaderSearchBar, Object.assign({}, searchBar, { ref: ref })),
    react_1.default.createElement(MenuItems, { headerLinks: headerLinks }),
    accessoryItem && react_1.default.createElement(accessory_item_1.AccessoryItem, Object.assign({}, accessoryItem)),
    isLoggedIn && userButton && (react_1.default.createElement(HeaderAvatar, Object.assign({}, userButton, { onLogoutClick: onLogoutClick }))),
    !isLoggedIn && (react_1.default.createElement(HeaderButton, { buttonType: "link", label: "Log In", target: "_blank", variation: "outline", emphasis: "secondary", href: loginUrl })),
    react_1.default.createElement(HeaderButtons, { buttons: buttons }))));
exports.Header = (0, react_1.forwardRef)((_a, ref) => {
    var { displayLogoIcon, headerLinks = [], isLoggedIn, buttons = [], accessoryItem, userButton, loginUrl = "", theme = "core", onLogoutClick, searchBar } = _a, props = __rest(_a, ["displayLogoIcon", "headerLinks", "isLoggedIn", "buttons", "accessoryItem", "userButton", "loginUrl", "theme", "onLogoutClick", "searchBar"]);
    const deviceWidth = (0, cgui_core_utilities_hooks_use_device_width_1.useDeviceWidth)();
    const { desktop, tabletLarge } = cgui_core_utilities_helpers_resolution_variables_1.breakpoints;
    const isCollapsedHeader = deviceWidth < tabletLarge;
    const isFullIconLogo = deviceWidth >= desktop && !displayLogoIcon;
    const mainMenuType = isFullIconLogo ? "full" : "icon";
    const logoWidth = isFullIconLogo
        ? "190px"
        : isCollapsedHeader
            ? "30px"
            : "40px";
    return (react_1.default.createElement("header", Object.assign({ className: header_module_scss_1.default.header }, props),
        react_1.default.createElement("a", { href: "/" },
            react_1.default.createElement(cgui_core_atoms_logo_1.Logo, { type: mainMenuType, width: logoWidth })),
        react_1.default.createElement("nav", { className: header_module_scss_1.default.nav }, isCollapsedHeader ? (react_1.default.createElement(CollapsedHeader, { headerLinks: headerLinks, isLoggedIn: isLoggedIn, deviceWidth: deviceWidth, accessoryItem: accessoryItem, buttons: buttons, userButton: userButton, loginUrl: loginUrl, onLogoutClick: onLogoutClick, theme: theme, searchBar: searchBar, ref: ref })) : (react_1.default.createElement(LargeHeader, { headerLinks: headerLinks, isLoggedIn: isLoggedIn, buttons: buttons, accessoryItem: accessoryItem, loginUrl: loginUrl, userButton: userButton, onLogoutClick: onLogoutClick, searchBar: searchBar, ref: ref })))));
});
//# sourceMappingURL=header.js.map